module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jIGip"))).then(() => module.bundle.root('hEqeo'));